import { fetchServices, fetchRebook } from '@/api/service'
import { fetchPaxsGroup } from '@/api/passenger'
import { fetchFlightHistory } from '@/api/flight'
import { params } from '@/api/instance'

const getSelectService = (context) => {
  fetchServices().then((response) => {
    context.commit('SELECTSERVICE_UPDATED', _.keyBy(response, 'service_id'))
  })
}
const getRebook = (context) => {
  fetchRebook().then((response) => {
    context.commit('REBOOK_GET', response)
  })
}
const getPaxsGroup = (context) => {
  fetchPaxsGroup().then((response) => {
    let tmp = _.find(response, function (o) {
      return o.passenger_id == params.paxId
    })
    tmp.flight_number = tmp.fltref.split('-')[0]
    context.commit('PAXSGROUP_UPDATED', tmp)
  })
}
const getFlightHistory = (context) => {
  fetchPaxsGroup().then((responsePaxsGroup) => {
    var ref = _.find(responsePaxsGroup, function (o) {
      return o.passenger_id == params.paxId
    }).first_fltref
    fetchFlightHistory(ref).then((responseFlightHistory) => {
      context.commit('FLIGHTHISTORY_GET', responseFlightHistory)
    })
  })
}
export default {
  getSelectService,
  getRebook,
  getFlightHistory,
  getPaxsGroup
}
